/* Skin Bar v20 motion: scroll reveal (IntersectionObserver) + second image on product-card hover. No libraries. */
(function () {
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(any-pointer: fine)').matches;

  /* ---- second image on hover ---- */
  function prepAlt(card) {
    if (card.dataset.sbAlt) return;
    card.dataset.sbAlt = '1';
    var imgs = card.querySelectorAll('.card-gallery .product-media__image');
    if (imgs.length < 2) return;
    var first = imgs[0], second = imgs[1];
    var holder = first.closest('.product-media');
    if (!holder) return;
    var alt = document.createElement('img');
    alt.className = 'sb-alt-img';
    alt.alt = '';
    alt.setAttribute('aria-hidden', 'true');
    alt.decoding = 'async';
    if (second.getAttribute('srcset')) { alt.srcset = second.getAttribute('srcset'); alt.sizes = first.getAttribute('sizes') || second.getAttribute('sizes') || '300px'; }
    alt.src = second.currentSrc || second.getAttribute('src');
    holder.appendChild(alt);
  }
  if (finePointer && !reduce) {
    document.addEventListener('pointerover', function (e) {
      var card = e.target && e.target.closest && e.target.closest('product-card');
      if (card) prepAlt(card);
    }, { passive: true });
  }

  /* ---- scroll reveal ---- */
  if (reduce || !('IntersectionObserver' in window)) return;
  doc.classList.add('sb-motion');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target;
      io.unobserve(el);
      el.classList.add('sb-in');
      /* drop the helper classes once done so hover transforms / sticky children behave normally */
      setTimeout(function () { el.classList.remove('sb-r', 'sb-in'); el.style.removeProperty('--sb-d'); }, 1300);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });

  function scan() {
    var vh = window.innerHeight || 800;
    var sections = document.querySelectorAll('main > .shopify-section');
    sections.forEach(function (sec, i) {
      if (i === 0 || sec.dataset.sbR) return;
      sec.dataset.sbR = '1';
      if (sec.querySelector('product-card')) return; /* product lists: animate the cards instead */
      if (sec.getBoundingClientRect().top < vh * 0.9) return; /* already on screen: never hide */
      sec.classList.add('sb-r');
      io.observe(sec);
    });
    document.querySelectorAll('main product-card').forEach(function (card) {
      if (card.dataset.sbR) return;
      card.dataset.sbR = '1';
      var r = card.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) return;
      var sibs = card.parentElement ? Array.prototype.indexOf.call(card.parentElement.parentElement ? card.parentElement.parentElement.children : [], card.parentElement) : 0;
      card.style.setProperty('--sb-d', ((Math.max(sibs, 0) % 4) * 80) + 'ms');
      card.classList.add('sb-r');
      io.observe(card);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  /* safety net: reveal anything still hidden after 6 s (e.g. print, odd scrollers) */
  setTimeout(function () { document.querySelectorAll('.sb-r:not(.sb-in)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < (window.innerHeight || 800)) el.classList.add('sb-in'); }); }, 6000);
})();
